<p-fieldset
    [legend]="'order.orderSummary' | translate"
    [id]="id() + '-fieldset'"
    class="custom-fieldset"
    [class.custom-success-fieldset]="fieldsetColor() === 'green'"
    [class.custom-danger-fieldset]="fieldsetColor() === 'red'">
    @if (orderSummaryInvoice()) {
        <div id="order-summary-invoice-submission-content" class="content">
            <div class="label-value-container">
                <label
                    >{{ 'orders.orderSummary.invoiceSubtotal' | translate }} ({{
                        orderSummaryInvoice().numberOfReactionPrimerCombos
                    }}):</label
                >
                <p>{{ orderSummaryInvoice().subtotal | currency: 'USD' }}</p>
            </div>
            @if (orderSummaryInvoice().numberOfCancelledReactions) {
                <div class="label-value-container">
                    <label
                        >{{ 'orders.orderSummary.invoiceCancellation' | translate }} ({{
                            orderSummaryInvoice().numberOfCancelledReactions
                        }}):</label
                    >
                    <p>{{ orderSummaryInvoice().cancellation | currency: 'USD' }}</p>
                </div>
            }
            <div class="label-value-container">
                <label>{{ 'orders.orderSummary.shippingAndHandling' | translate }}:</label>
                <p>{{ orderSummaryInvoice().shippingAndHandling | currency: 'USD' }}</p>
            </div>
            <p-divider></p-divider>
            <div id="order-summary-invoice-total" class="label-value-container">
                <label> {{ 'orders.orderSummary.invoiceTotal' | translate }}:</label>
                <p>{{ orderSummaryInvoice().estimatedTotal | currency: 'USD' }}</p>
            </div>
            @if (hideSubmitSection() === false) {
                <div id="order-summary-invoice-disclaimer">
                    <p [innerHTML]="'orders.orderSummary.invoiceDisclaimer' | translate"></p>
                </div>
                <div>
                    <p-button
                        id="order-summary-submit-button"
                        [label]="'orders.orderSummary.submitOrder' | translate"
                        (click)="submitOrderEvent.emit()">
                    </p-button>
                </div>
            }
        </div>
    } @else {
        <app-loader></app-loader>
    }
</p-fieldset>
